import React, { useEffect, useState } from 'react';
import { Card, Table } from 'react-bootstrap';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Link } from 'react-router-dom';
import { CallMade, DeleteOutlineOutlined, EditOutlined, HomeOutlined, InsertDriveFileRounded, NearMe, NfcOutlined, } from "@material-ui/icons";
import useAuth from '../Login/useAuth';
import Navigation from '../Navigation';

import '../Crud/Adduser.css'

const Adduser = () => {
    const { user } = useAuth()
    const [users, setUser] = useState([])
    const [single, setSingle] = useState([])

    useEffect(() => {
        fetch('https://thawing-ridge-28572.herokuapp.com/users')

            .then(res => res.json())
            .then(data => {
                setUser(data)
            })
    }, [users])

    const handleDelte = (id) => {
        const procced = window.confirm('are You Sure You Wante Delete')
        if (procced) {
            fetch(`https://thawing-ridge-28572.herokuapp.com/users/${id}`, {
                method: 'DELETE'
            })
                .then(res => res.json())
                .then(data => {
                    if (data.deletedCount > 0) {
                        alert('delete SuccessFully')
                        const remainingUser = users.filter(user => user._id !== id)
                        setUser(remainingUser)
                    }
                })
        }
    }

    const handleDelteSingle = (id) => {
        const procced = window.confirm('are You Sure You Wante Delete')
        if (procced) {

            fetch(`https://thawing-ridge-28572.herokuapp.com/single/${id}`, {
                method: 'DELETE'
            })
                .then(res => res.json())
                .then(data => {
                    if (data.deletedCount > 0) {
                        alert('delete SuccessFully')
                        const remainingUser = single.filter(user => user._id !== id)
                        setUser(remainingUser)
                    }
                })
        }
    }


    useEffect(() => {
        const url = `https://thawing-ridge-28572.herokuapp.com/single?email=${user?.email}`

        fetch(url)
            .then(res => res.json())
            .then(data => setSingle(data))
    }, [user.email, single])
    AOS.init();

    return (
        <>
            <Navigation></Navigation>

            <div className=" text-dark ">

                <div className='  '>
                    <div className='   shadow-sm   bg-body rounded'>

                        <hr />


                        {user?.email ? <div className='container mb-5'>
                            <h4> <em className='fs-4 '>  {user?.displayName}</em> Please Add A New user</h4>
                            <div className="row ">
                                {single.map(s =>

                                    <div className="col-md-12 ">
                                        <div className="row ">
                                            <div className="col-md-6 text-start">
                                                <Card
                                                    data-aos="flip-left"
                                                    data-aos-easing="ease-out-cubic"
                                                    data-aos-duration="3000"

                                                    className='cardsss' style={{ width: '18rem' }}>

                                                    {user.photoURL && <div className="text-center">
                                                        <Card.Img className='rounded-circle w-50 h-50 text-center' variant="top" src={user?.photoURL} />
                                                    </div>}
                                                    <Card.Body>
                                                        <Card.Title>
                                                            <em className='text-dark fs-4 text-primary'>  Name : </em>
                                                            {s.name}</Card.Title>
                                                        <Card.Text>
                                                            <em className='text-dark fs-4 text-primary'>    Email : </em>
                                                            {s.email}
                                                        </Card.Text>
                                                        <Card.Text>
                                                            <em className='text-dark fs-4 text-primary'>    Number : </em>
                                                            {s.number}
                                                        </Card.Text>
                                                        <Card.Text>
                                                            <em className='text-dark fs-4 text-primary'>    Address : </em>
                                                            {s.address}
                                                        </Card.Text>
                                                        <Card.Text>
                                                            <em className='text-dark fs-4 text-primary'>    Profession: </em>
                                                            {s.relegion}
                                                        </Card.Text>
                                                    </Card.Body>
                                                </Card>
                                            </div>
                                            <div
                                                className="col-md-6 text-start my-5">
                                                <Card

                                                    data-aos="flip-right"
                                                    data-aos-easing="ease-out-cubic"
                                                    data-aos-duration="3000"
                                                    className='text-start my-5'
                                                    style={{ width: '25rem' }}>
                                                    <Card.Body>

                                                        <div className=" d-flex text-start fs-4">
                                                            <InsertDriveFileRounded></InsertDriveFileRounded>
                                                            <Card.Text>{s?.name}</Card.Text>
                                                        </div>
                                                        <div className=' d-flex text-start'>
                                                            <NearMe></NearMe>
                                                            <Card.Text>
                                                                {s?.email}
                                                            </Card.Text>
                                                        </div>



                                                        <hr />
                                                        <div className="text-start">
                                                            <div className='d-flex text-start'>
                                                                <CallMade />
                                                                <Card.Text>
                                                                    {s?.number}
                                                                </Card.Text>
                                                            </div>
                                                            <div className='d-flex text-start'>
                                                                <HomeOutlined />
                                                                <Card.Text>
                                                                    {s?.address}
                                                                </Card.Text>
                                                            </div>
                                                            <div className=" d-flex text-start">
                                                                <NfcOutlined ></NfcOutlined>

                                                                <Card.Text>
                                                                    {s?.relegion}
                                                                </Card.Text>
                                                            </div>
                                                        </div>
                                                        <div className=''>

                                                            <Link
                                                                to={`/emailusers/${s?._id}`}

                                                            >
                                                                <button className='ms-1 mt-3 btn btn-outline-dark btn-lg'> <EditOutlined /> Update Your Profile </button>
                                                            </Link>
                                                            <div className="d-flex justify-content-end">
                                                                <button onClick={() => handleDelteSingle(s?._id)} className=' btn btn-danger '>                               <DeleteOutlineOutlined />
                                                                </button>
                                                            </div>

                                                        </div>
                                                    </Card.Body>
                                                </Card>

                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                            :
                            <div className="bg-dark p-5">
                                <div className='row  d-flex text-start'>

                                    {
                                        users.map((s, i) =>
                                            <div className="col-md-6 mb-3 ">
                                                <Card
                                                    data-aos="flip-left"
                                                    data-aos-easing="ease-out-cubic"
                                                    data-aos-duration="3000"
                                                    // data-aos-duration="1500"
                                                    style={{ width: '25rem' }}>
                                                    <div className=" ">
                                                        <div class="cardIndex position-absolute top-0 end-0 me-3
                                                       
                                                        ">
                                                            <Link
                                                                className='cardIndex '
                                                                to={`/users/${s?._id}`}

                                                            >
                                                                <em>{i}</em>
                                                            </Link>


                                                        </div>
                                                        <Card.Body>
                                                            <div className=" d-flex justify-content-center align-items-start ">

                                                                <InsertDriveFileRounded></InsertDriveFileRounded>
                                                                <Card.Text>Name:{s?.name}</Card.Text>
                                                            </div>
                                                            <div className=' d-flex text-start'>
                                                                <NearMe></NearMe>
                                                                <Card.Text>
                                                                    Email: {s?.email}
                                                                </Card.Text>
                                                            </div>


                                                            <hr />
                                                            <div className="d-flex text-start">

                                                                <div className="">
                                                                    <div className="">
                                                                        <div className='text-start d-flex justify-content-start align-items-start'>
                                                                            <CallMade />
                                                                            <Card.Text className=''>
                                                                                Number: {s?.number}
                                                                            </Card.Text>
                                                                        </div>
                                                                        <div className='d-flex justify-content-start align-items-center'>
                                                                            <HomeOutlined />
                                                                            <Card.Text>
                                                                                Home:  {s?.address}
                                                                            </Card.Text>
                                                                        </div>
                                                                        <div className=" d-flex justify-content-start align-items-start">
                                                                            <NfcOutlined ></NfcOutlined>

                                                                            <Card.Text>
                                                                                Position: {s?.relegion}
                                                                            </Card.Text>
                                                                        </div>
                                                                    </div>
                                                                    <div className='d-flex mt-3 justify-content-start'>

                                                                        <button onClick={() => handleDelteSingle(s?._id)} className=' btn btn-danger btn-'>                               <DeleteOutlineOutlined />
                                                                        </button>
                                                                        <Link
                                                                            to={`/users/${s?._id}`}

                                                                        >
                                                                            <button className='mx-3 fs-5 btn btn-success btn-sm'> <EditOutlined /></button>
                                                                        </Link>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Card.Body>

                                                    </div>
                                                </Card>

                                            </div>
                                        )
                                    }
                                </div>
                            </div>}

                    </div>

                </div>

            </div>
        </>

    );
};

export default Adduser;